<template>
  <zj-layout-container>
    <zj-layout-header v-if="isHeadVisiable">
      <div class="listtitle">通讯录详情</div>
    </zj-layout-header>
    <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
      <div class="zj-layout-main-content bgcolor scrollable">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
        <el-form-item label="姓名" prop="PersonName" style="display:inline-block;">
          <el-input v-model="ruleForm.PersonName" style="width:60rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="年龄" prop="Age" style="display:inline-block;">
          <el-input v-model="ruleForm.Age" style="width:60rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="所属应急组织类型" prop="ResourceTypeId" style="display:inline-block;">
          <el-radio-group
            v-model="ruleForm.ResourceTypeId"
            style="width:60rem;"
            v-bind:disabled="IsEdit"
            @change="radioChanaged"
          >
            <el-radio
              v-for="item in options"
              :key="item.ItemKey"
              :label="item.ItemKey"
              :value="item.ItemKey"
              style="margin-top: 0.4rem;margin-bottom:0.4rem;"
            >{{item.Extend1}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="所属组织结构" prop="PersonOrgianiztionId" style="display:inline-block;">
          <el-select
            v-model="ruleForm.PersonOrgianiztionId"
            placeholder="请选择所属组织结构"
            v-bind:disabled="IsEdit"
            style="width:60rem;"
          >
            <el-option
              v-for="item in options2"
              :key="item.PersonOrgianiztionId"
              :label="item.OrgianizationName"
              :value="item.PersonOrgianiztionId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人移动电话" prop="PhoneNum" style="display:inline-block;">
          <el-input v-model="ruleForm.PhoneNum" style="width:60rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="职称" prop="TitleName" style="display:inline-block;">
          <el-input v-model="ruleForm.TitleName" style="width:60rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="出生日期" prop="Birthday" style="display:inline-block;">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="ruleForm.Birthday"
            style="width:60rem;"
            v-bind:disabled="IsEdit"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="性别" prop="Sex" style="display:inline-block;">
          <el-radio-group v-model="ruleForm.Sex" style="width:60rem;" v-bind:disabled="IsEdit">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否负责人" prop="IsPrincipal" style="display:inline-block;">
          <el-radio-group v-model="ruleForm.IsPrincipal" style="width:60rem;" v-bind:disabled="IsEdit">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="简介" prop="Remark" style="display:inline-block;">
          <el-input
            type="textarea"
            v-model="ruleForm.Remark"
            style="width:60rem;"
            v-bind:disabled="IsEdit"
          ></el-input>
        </el-form-item>
      </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <div style="text-align:center;">
        <el-button v-if="opentype" @click="onClose()">返回</el-button>
        <template v-else>
          <el-button @click="onBack()">返回</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">保存</el-button>
          <el-button @click="resetForm('')" v-show="IsEdit==false">重置</el-button>
        </template>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
  
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "ZjAddressbookinfo",
  controller: "EmergencyResource",
  action: "Addressbookinfo",
  props: {
    isHeadVisiable: { type: Boolean, default: true },
    opentype: { type: Boolean, default: false },
    playerInfo: { type: Object }
  },
  watch: {
    playerInfo(newV) {
      if (newV) {
        this.ruleForm = newV;
        this.IsEdit = this.opentype;
      }
    }
  },
  data() {
    return {
      ruleForm:
        this.$route.query.obj == null
          ? {
              PersonName: "",
              ResourceTypeId: this.$route.query.ResourceTypeId,
              PersonOrgianiztionId: "",
              PhoneNum: "",
              TitleName: "",
              Sex: 1,
              IsPrincipal: 0,
              Birthday: new Date(),
              Age: "",
              Remark: ""
            }
          : this.$route.query.obj,
      options: [],
      options2: [],
      rules: {
        PersonName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 1, max: 15, message: "长度在 1 到 15 个字符", trigger: "blur" }
        ],
        ResourceTypeId: [
          {
            required: true,
            message: "请选择所属应急组织类型",
            trigger: "charge"
          }
        ],
        PersonOrgianiztionId: [
          { required: true, message: "请选择组织结构", trigger: "charge" }
        ],
        PhoneNum: [
          { required: true, message: "请输入联系方式", trigger: "blur" }
        ],
        IsPrincipal: [
          { required: true, message: "请输入是否负责人", trigger: "charge" }
        ],
        IsEdit: false
        //desc: [{ required: true, message: "请填写备注", trigger: "blur" }]
      }
    };
  },
  created: function() {
    this.basedatabind();
    this.IsEdit = this.$route.query.type == "edit" ? false : true;
     if (this.playerInfo) {
        this.ruleForm = this.playerInfo;
        this.IsEdit = this.opentype;
      }
  },
  mounted: function() {},
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    //基础数据绑定
    basedatabind() {
      //所属应急组织类型
      this.config
        .getUValue("EmergencyService:PersonOrgianiztionType:", "")
        .then(d => {
          this.options = d.JValue;
        })
        .catch(e => console.error(e));

      this.SearchOrginze(this.$route.query.ResourceTypeId);
    },
    radioChanaged(val) {
      this.SearchOrginze(val);
    },

    SearchOrginze(ResourceTypeId) {
      //所属组织结构
      let searchInfo = {
        PageSize: 20,
        PageIndex: 1,
        ResourceTypeId: ResourceTypeId,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      new MyApis.PersonOrganiztionApi()
        .FindByConditions(searchInfo)
        .then(r => {
          r = r.data.Data;
          this.options2 = r;
        })
        .catch(e => {
          console.log(e);
          //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },

    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    onClose() {
      this.$emit("onClose", {});
    },
    //重置
    resetForm(formName) {
      this.ruleForm = formName;
      //this.$refs[formName].resetFields();
      this.$route.query.obj = null;
    },
    save() {
      //this.ruleForm.OrgianiztionTypeId = this.ruleForm.OrgianiztionTypeId.toString();
      console.log(this.ruleForm);
      if (this.$route.query.obj == null) {
        new MyApis.AddressbookApi()
          .AddItem(this.ruleForm)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.logInfo.ActionName = "应急通讯录添加";
            this.logInfo.LogMessage = r ? "应急通讯录添加成功" : "应急通讯录添加失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "应急通讯录管理详情页面";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        new MyApis.AddressbookApi()
          .UpdateItem(this.ruleForm)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.logInfo.ActionName = "应急通讯录修改";
            this.logInfo.LogMessage = r ? "应急通讯录修改成功" : "应急通讯录修改失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "应急通讯录管理详情页面";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.error("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    }
  }
};
</script>